import { render, staticRenderFns } from "./bet-detail.vue?vue&type=template&id=645b20d2&scoped=true"
import script from "./bet-detail.vue?vue&type=script&lang=js"
export * from "./bet-detail.vue?vue&type=script&lang=js"
import style0 from "./bet-detail.vue?vue&type=style&index=0&id=645b20d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b20d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645b20d2')) {
      api.createRecord('645b20d2', component.options)
    } else {
      api.reload('645b20d2', component.options)
    }
    module.hot.accept("./bet-detail.vue?vue&type=template&id=645b20d2&scoped=true", function () {
      api.rerender('645b20d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/bet-detail.vue"
export default component.exports